import { gql } from '@apollo/client';

export const GET_RECIPE_CATEGORIES = gql`
  query GetRecipeCategories {
    categories(first: 1000) {
      title
    }
  }
`;
